import { render } from "./UkgApiTest.vue?vue&type=template&id=ea72f048&scoped=true"
import script from "./UkgApiTest.vue?vue&type=script&lang=js"
export * from "./UkgApiTest.vue?vue&type=script&lang=js"

import "./UkgApiTest.vue?vue&type=style&index=0&id=ea72f048&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea72f048"]])

export default __exports__